import NodeModel from './nodemodel.vue'
export default NodeModel



// WEBPACK FOOTER //
// ./src/lib/components/nodemodel/index.js